import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const capabilities = ['Attack-path validation', 'AI application security', 'Cloud and identity risk', 'External exposure', 'Code and secrets review', 'Internal exposure', 'Remediation guidance', 'Fix verification', 'Evidence packs', 'Customer-ready reporting', 'MSSP-ready workflows'];
const outputs = ['Here are the paths that matter.', 'Here is why they matter.', 'Here is how to fix them.', 'Here is how to prove they are gone.'];
export function Product() {
  return <section id="product" className="relative w-full py-32 border-t border-white/5" data-id="element-1235">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1236">
        <SectionLabel number="05" label="Product Overview" className="mb-8" data-id="element-1237" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-1238">
          <div className="lg:col-span-7" data-id="element-1239">
            <SectionHeading size="xl" data-id="element-1240">What Periscan does.</SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-1241">
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-1242">
              Periscan is a self-serve platform that continuously validates how
              a company could actually be compromised. Connect via API in
              minutes, run agentless validation, and get clear, evidence-backed
              answers without waiting on a services team.
            </p>
          </div>
        </div>

        {/* Capabilities editorial list */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0 mb-20" data-id="element-1243">
          {capabilities.map((cap, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.04
        }} className="flex items-center gap-6 py-5 border-b border-white/5" data-id="element-1244">
              <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-1245">
                {String(i + 1).padStart(2, '0')}
              </span>
              <p className="text-base font-medium text-white" data-id="element-1246">{cap}</p>
            </motion.div>)}
        </div>

        {/* The output */}
        <div className="rounded-2xl bg-[#070a0e] border border-white/5 p-10 md:p-16" data-id="element-1247">
          <p className="font-mono text-xs uppercase tracking-widest text-[#1a8fd4] mb-8" data-id="element-1248">
            The Output
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-1249">
            {outputs.map((output, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} className="flex items-baseline gap-4" data-id="element-1250">
                <span className="font-mono text-sm text-[#1a8fd4]/60" data-id="element-1251">
                  /{i + 1}
                </span>
                <p className="text-2xl md:text-3xl font-medium text-white tracking-tight" data-id="element-1252">
                  {output}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}